module.exports = __webpack_public_path__ + "assets/2da428c34805421b5757a23638e67137.mp3";